import { initializeCursor } from '../shared/cursor.ts';
import { initializeNavigation, initializeScrollAnimations } from '../shared/navigation.ts';

// Initialize page
function initAboutPage() {
  // Initialize cursor
  initializeCursor();

  // Initialize navigation
  initializeNavigation();

  // Initialize scroll animations
  initializeScrollAnimations();

  // Page-specific functionality
  console.log('About page initialized');
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAboutPage);
} else {
  initAboutPage();
}
